export function caregiverPatientSearch() {
    return {
        restrict: 'E',
        templateUrl: 'admin/views/caregiver-patient-search.html',
        scope: {
            // Optional. When omitted the picker searches the server instead of
            // filtering a caller-supplied collection.
            items: '<?',
            preSelectedItem: '<',
            isDisabled: '<',
            isMultiple: '<?',
            showError: '<',
            enableCaregiverChat: '<',
            type: '@',
            chatPatientId: '<?',
            handleSelect: '&',
            handleDeselect: '&',
            showOnlyActive: '<?',
            // Optional server-side narrowing, so a caller that only wants
            // caregivers holding certain certifications does not have to hold a
            // collection to filter.
            certifications: '<?',
            showStatus: '<?',
            hideAvatar: '<?',
            hidePofilePicture: '<?'
        },
        /* @ngInject */
        controller: function ($scope, $rootScope, $filter, $http, $timeout, Consts) {
            // Server-backed search. `items` is only consulted when a caller still
            // passes a collection; without it nothing is held in memory and every
            // keystroke asks the search index instead.
            const SEARCH_LIMIT = 5;
            const DEBOUNCE_MS = 200;

            $scope.results = [];
            $scope.isSearching = false;

            function searchUrl() {
                const kind = $scope.type === 'patient' ? 'patients' : 'caregivers';
                return Consts.api + 'agencies/' + $rootScope.agencyId +
                    '/agency_members/' + $rootScope.agencyMemberId + '/search/' + kind;
            }

            // The dropdown used to prettify status and default the photo by writing
            // onto the shared dictionary entry. Do it on our own copy instead.
            function present(item) {
                return angular.extend({}, item, {
                    photoUrl: item.photoUrl || 'admin/images/blank-profile.jpg',
                    status: (item.status || '').replace('_', ' ')
                });
            }

            function localResults(term) {
                const filtered = $filter('caregiverPatientSearchFilter')(
                    $scope.items, term, $scope.isMultiple, $scope.showOnlyActive, $scope.selectedItems);
                return Object.values(filtered);
            }

            let searchSeq = 0;
            let debounce = null;

            function runSearch(term) {
                if ($scope.items !== undefined) {
                    $scope.results = localResults(term);
                    return;
                }

                if (!term) {
                    $scope.results = $scope.isMultiple ? ($scope.selectedItems || []) : [];
                    return;
                }

                const seq = ++searchSeq;
                $scope.isSearching = true;

                const query = { q: term, limit: SEARCH_LIMIT };
                if ($scope.showOnlyActive === true) {
                    query.status = 'ACTIVE';
                }
                if (Array.isArray($scope.certifications) && $scope.certifications.length > 0) {
                    query.certifications = $scope.certifications.join(',');
                }

                $http.get(searchUrl(), { params: query }).then(function (res) {
                    // Drop anything a later keystroke has already superseded.
                    if (seq !== searchSeq) return;
                    $scope.results = (res.data.items || []).map(present);
                    $scope.isSearching = false;
                }).catch(function () {
                    if (seq !== searchSeq) return;
                    $scope.results = [];
                    $scope.isSearching = false;
                });
            }

            $scope.onSearchTextChange = function () {
                if (debounce !== null) $timeout.cancel(debounce);
                debounce = $timeout(function () {
                    runSearch($scope.itemFilter.val);
                }, DEBOUNCE_MS);
            };

            // Resolving a pre-selected id no longer needs the whole collection.
            //
            // This asks for the id as an exact filter, not as search text: an id
            // is one searchable field among many, so a short one is outranked by
            // substring hits on phone numbers and SSNs and can fall outside the
            // page entirely - most ids never came back at all that way.
            function resolveById(id) {
                $http.get(searchUrl(), { params: { ids: String(id), limit: 1 } })
                    .then(function (res) {
                        const match = (res.data.items || [])[0];
                        if (match !== undefined) $scope.selectedItem = present(match);
                    });
            }

            // Same for a pre-selected list: one request for the whole list, not
            // one per id.
            function resolveByIds(ids) {
                $http.get(searchUrl(), { params: { ids: ids.join(','), limit: ids.length } })
                    .then(function (res) {
                        $scope.selectedItems = (res.data.items || []).map(present);
                    });
            }

            $scope.selectedItem = null;
            $scope.selectedItems = [];
            if ($scope.preSelectedItem) {
                if ($scope.isMultiple === true) {
                    if ($scope.items !== undefined) {
                        const preItems = [];
                        Object.values($scope.items).forEach((item) => {
                            if ($scope.preSelectedItem.indexOf(item.id) >= 0) {
                                preItems.push(item);
                            }
                        });
                        $scope.selectedItems = preItems;
                    } else {
                        const objects = $scope.preSelectedItem.filter(
                            (item) => item !== null && typeof item === 'object');
                        const ids = $scope.preSelectedItem.filter(
                            (item) => item !== null && typeof item !== 'object');
                        $scope.selectedItems = objects;
                        if (ids.length > 0) resolveByIds(ids);
                    }
                } else if (typeof $scope.preSelectedItem === 'object') {
                    $scope.selectedItem = present($scope.preSelectedItem);
                } else {
                    resolveById($scope.preSelectedItem);
                }
            }

            $scope.itemFilter = { val: '' };
            
            $scope.placeholder = $scope.type === 'caregiver' ?
                'Select caregiver...' : 'Select patient...';

            $scope.initials = function (item) {
                if (item === null || item === undefined) return '';
                const first = (item.firstName || '').substr(0, 1);
                const last = (item.lastName || '').substr(0, 1);
                return first + last;
            };

            // Results are fresh objects from the server, so identity comparison
            // against the selection no longer holds - match on id.
            $scope.isSelected = function (item) {
                return ($scope.selectedItems || []).some(function (selected) {
                    return String(selected.id) === String(item.id);
                });
            };

            $scope.onItemSelect = function (item) {
                if ($scope.showError) {
                    $scope.showError = false;
                }
                if($scope.isMultiple === true){
                    const idx = $scope.selectedItems.findIndex(function (selected) {
                        return String(selected.id) === String(item.id);
                    });
                    if (idx !== -1) {
                        $scope.selectedItems.splice(idx, 1);
                    } else {
                        $scope.selectedItems.push(item);
                    }
                    $scope.handleSelect({ item: $scope.selectedItems });
                }else{
                    $scope.itemFilter.val = '';
                    $scope.selectedItem = item;
                    $scope.handleSelect({ item: item });
                }
            }

            $scope.onItemDeSelect = function () {
                $scope.itemFilter.val = '';
                $scope.selectedItem = null;
                $scope.selectedIndex = -1;
                $scope.handleDeselect();
            }

            $scope.selectedIndex = -1;

            $scope.searchKeyUp = function (event) {
                const resultsPreview = $scope.results;
                const resultsAmount = resultsPreview.length;
                switch (event.key) {
                    case 'Enter': {
                        if ($scope.selectedIndex > -1 && $scope.selectedIndex < resultsAmount) {
                            $scope.onItemSelect(resultsPreview[$scope.selectedIndex]);
                        }
                                
                        break;
                    }
                    case 'Escape': {
                        $scope.onItemDeSelect();
                        break;
                    }
                    case 'ArrowDown': {
                        if ($scope.selectedIndex < resultsAmount - 1) {
                            $scope.selectedIndex++;
                        }
                        break;
                    }
                    case 'ArrowUp': {
                        if ($scope.selectedIndex > -1) {
                            $scope.selectedIndex--;
                        }
                        break;
                    }
                    default: {
                        $scope.selectedIndex = -1;
                        $scope.onSearchTextChange();
                        break;
                    }
                }
            }

            $scope.openChat = (selectedItem) => {
                if ($scope.chatPatientId) {
                    selectedItem.fromList = true;
                    selectedItem.chatRoomType = {
                        caregiverId: selectedItem.id,
                        patientId: $scope.chatPatientId,
                    };
                    $rootScope.openChat(selectedItem);
                } else {
                    selectedItem.chatRoomType = {
                        agencyId: $rootScope.agencyId,
                        agencyMemberId: $rootScope.agencyMemberId,
                        caregiverId: selectedItem.id,
                        type: "AgencyMemberCaregiverChat"
                    };
                    $rootScope.openAgencyChat(selectedItem.id);
                }
            }

            $scope.$on('cleanSelection',function(event, data){
                $scope.onItemDeSelect();
            });
        }
    };
};